/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

//import StepItem from '../../components/StepItem'
import VoiceItem from '../../components/VoiceItem';

class StepList extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { cv_Idx } = this.props.childProps;
    this._getData(cv_Idx);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.cv_Idx !== nextProps.childProps.cv_Idx;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (this.props.childProps.cv_Idx !== nextProps.childProps.cv_Idx) {
      this._getData(nextProps.childProps.cv_Idx);
    }
  };
  _getData = async (cv_Idx) => {
    // const { contentSerial } = this.props.childProps;

    if (cv_Idx === '' || cv_Idx === null || cv_Idx === undefined) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi(cv_Idx);
      const intReturn = result.data[0].intReturn;
      const stepList = result.data[0].listData;
      //console.log(stepList)
      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            stepList,
          });
        }
      }
    }
  };

  _getDataApi = (cv_Idx) => {
    const { apiUrl, loginId } = this.props;
    //const { cv_Idx } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)

    return axios(apiUrl + '/voiceList?cv_Idx=' + cv_Idx + '&userid=' + loginId)
      .then((response) => response)
      .catch((error) => {
        // alert("등장인물 데이터를 로드 중 오류가 발생했습니다.");
      });
  };
  /*
    _stepClick = (cv_Idx) => {
        const { stepClick } = this.props.childProps;
        stepClick(cv_Idx)
    }
    */
  _renderItem = () => {
    const { stepList } = this.state;

    const list = stepList.map((item, index) => {
      return (
        <VoiceItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          stepName={item.stepName}
          stepImage={item.stepImage}
          comment={item.comment}
          kname={item.kname}
          stepClose={this._stepClose}
        />
      );
    });

    return list;
  };
  _stepClose = () => {
    const { stepClose } = this.props.childProps;
    stepClose();
  };
  render() {
    const { stepList } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        {stepList ? (
          <div className="detil_group2" style={{ paddingTop: 20 }}>
            <h1>
              {stepList[0].kname} 성우가 출연한 작품
              <div
                style={{
                  position: 'absolute',
                  right: 10,
                  top: 5,
                  cursor: 'pointer',
                }}
                onClick={this._stepClose}
              >
                <img src={imgUrl + '/img/detail_img/close_1.png'} />
              </div>
            </h1>
            <div className="inmul_list_group">
              <div className="div_ul">
                {stepList ? this._renderItem() : null}
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StepList));
